import { render, staticRenderFns } from "./presentationBox.vue?vue&type=template&id=1b009d26&scoped=true"
import script from "./presentationBox.vue?vue&type=script&lang=js"
export * from "./presentationBox.vue?vue&type=script&lang=js"
import style0 from "./presentationBox.vue?vue&type=style&index=0&id=1b009d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b009d26",
  null
  
)

export default component.exports